<template>
  <div class="left">
    <div class="userImg">
      <img id="aside-tab-headImg" :src="user.img" alt="" height="100">
      <h3 class="nick-name" :title="user.name">{{ user.name }}</h3>
      <a href="/consult">预约咨询</a>
    </div>
    <div class="tab">
      <template v-for="(item , index ) in userNav">
        <router-link :to="item.path" :key="index">
          <el-badge v-if="item.name=='我的预约'" :value="message" class="item" :max="99" :hidden="message==0">
            {{ item.name }}
          </el-badge>
          <el-badge v-else-if="item.name=='系统通知'" :value="systemMessage" class="item" :max="99"
                    :hidden="systemMessage==0">{{ item.name }}
          </el-badge>
          <template v-else>{{ item.name }}</template>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';
import {mapGetters, mapMutations} from 'vuex';
import {badge} from 'element-ui';
import {postAxios, getAxios} from "@/api/http";

export default {
  name: "tabCommon",
  data() {
    return {
      user: {},
      userNav: [
        {name: "我的预约", path: "/user/counsel"},
        {name: "关注医师", path: "/user/physician"},
        {name: "心理测试", path: "/user/psyTest"},
        {name: "我的优惠券", path: "/user/mineCoupon"},
        {name: "个人信息", path: "/user/center"},
        {name: "私信消息", path: "/user/communicate"},
        {name: "系统通知", path: "/user/message"},
        // {name: "专家会诊", path: "/user/expertCon"},
        // {name: "专家讲座", path: "/user/expertLect"},
      ]
    }
  },
  computed: {
    ...mapGetters(['message']),
    ...mapGetters(['systemMessage'])
  },
  components: {[badge.name]: badge},
  mounted() {
    let vm = this;
    vm.$ajax.post(base.api.current)
        .then((res) => {
          if (res.data.status == 'success') {
            vm.user = res.data.data;
          }
        })
    // 获取未读消息数
    getAxios(base.api.appoint.message).then((res) => {
      if (res.data.status == 'success') {
        vm.setMessage(res.data.data);
      }
    })
  },
  methods: {
    ...mapMutations(['setMessage']),
    ...mapMutations(['setSystemMessage'])
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

h3.nick-name {
  width: 192px;
  text-align: center;
  height: 38px;
  padding: 0 4px;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
